import React from "react";

const Blogone = () => {
  return (
    <div>
      <p className="text-2xl font-bold    py-5 px-10">রোগীর দোরগোড়ায় স্বাস্থ্যসেবা</p>
      <p className="text-xl      px-10">হেলথকেয়ার এট হোম</p>
      <p className="text-xl      px-10">০৯ জানুয়ারি ২০২৩, ২১:৫৫</p>
      <img
        className="py-5  px-10 rounded-md  	"
        src="https://cdn.jagonews24.com/media/imgAllNew/BG/2019November/dd-20230110120818.jpg"
        alt=""
      />
      <p className="px-10">
        ষাটোর্ধ্ব জাহানারা বেগম থাকেন গুলশানে। বিশাল বাসায় সারাদিন একাই থাকতে হয়
        তাকে। অবশ্য তাকে সহায়তা করার জন্য আছেন কয়েকজন গৃহকর্মী। একমাত্র সন্তান
        রাফসান জামান জীবিকার তাগিদে স্ত্রী সন্তান নিয়ে থাকেন যুক্তরাষ্ট্রে।
        ইদানিং বয়সের ভারে জাহানারা বেগমের শরীর আর আগের মতো সাড়া দেয় না। ওদিকে
        ছেলেও সব সময় মায়ের স্বাস্থ্য নিয়ে দুঃশ্চিন্তা করেন। ডিসেম্বরের মাঝামাঝি
        সময় একদিন হঠাৎ গৃহকর্মীর ফোন পান রাফসান জামান। ফোন রিসিভ করতেই কান্নার
        আওয়াজ শুনতে পান তিনি। অপর প্রান্ত থেকে গৃহকর্মী জানান, খালাম্মার শরীর
        খুব খারাপ। হাসপাতালে নিতে হবে। এত রাতে কে তাকে হাসপাতালে নেবে সেই
        চিন্তায় বাকরুদ্ধ রাফসান। পাশেই বসা ছিলেন রাফসানের স্ত্রী। হঠাৎ তিনি ফোনে
        কার সঙ্গে যেন কথা বলা শুরু করলেন। পরে জানতে পারলেন ‘হেলথ কেয়ার অ্যাট
        হোম’ (এইচসিএএইচ)-এর ইমার্জেন্সি নম্বরে ফোন করে শাশুড়ির জন্য বাসায়
        চিকিৎসক ও নার্স পাঠানোর অনুরোধ করেছেন। পরবর্তী ১০ মিনিটের মধ্যে গুলশানের
        বাসায় উপস্থিত হন একজন ডাক্তার ও একজন নার্স। প্রাথমিক চিকিৎসা পেয়ে
        পরবর্তী কয়েক ঘণ্টার মধ্যে একটু সুস্থবোধ করতে লাগলেন জাহানারা বেগম।
        প্রযুক্তির কল্যাণে প্রতিদিনই জাহানারা বেগমের মতো এমন শতশত মানুষ প্রয়োজন
        মতো বাসায় বসে স্বাস্থ্য সেবা নিচ্ছেন। এমনই একটি উদ্ভাবনী উদ্যোগ হলো
        ‘হেলথ কেয়ার অ্যাট হোম’। ২০১৯ সালে গড়ে ওঠা স্বাস্থ্যসেবাদাতা এ
        প্রতিষ্ঠানটি ২০২০ সালের ফেব্রুয়ারিতে কার্যক্রম শুরু করে। এইচসিএএইচ বাসায়
        গিয়ে যেসব স্বাস্থ্যসেবা প্রদান করে, তার মধ্যে রয়েছে— নার্সিং, মেডিক্যাল
        কেয়ারগিভিং, ফিজিওথেরাপি, মেডিক্যাল অ্যাসিস্ট্যান্স, কাউন্সেলিং এবং
        কম্প্যানিয়নশিপ। এছাড়া, মেডিক্যাল ইক্যুইপমেন্ট সুবিধাও গ্রহণ করা যাবে
        এইচসিএএইচ থেকে। এইচসিএএইচ রোগীদের ২৪ ঘণ্টা পর্যবেক্ষণ এবং তত্ত্বাবধানের
        নিশ্চয়তা দিচ্ছে। প্রতিষ্ঠানটি শুধু রোগীদের মানসম্মত সেবা প্রদানের মধ্যেই
        নিজেদের কার্যক্রম সীমাবদ্ধ রাখেনি। প্রতিষ্ঠানটি ঢাকা বিশ্ববিদ্যালয়ের
        অধিভুক্ত স্টেট কলেজ অব হেলথ সায়েন্সেসের মাধ্যমে বিএসসি ডিগ্রিও প্রদান
        করছে।
      </p>
    </div>
  );
};

export default Blogone;
